import { render, staticRenderFns } from "./my-documents.vue?vue&type=template&id=337325f6&scoped=true&"
import script from "./my-documents.vue?vue&type=script&lang=js&"
export * from "./my-documents.vue?vue&type=script&lang=js&"
import style0 from "./my-documents.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./my-documents.vue?vue&type=style&index=1&id=337325f6&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "337325f6",
  null
  
)

export default component.exports